import { useRef } from 'react';
import { consumePostLoginRedirect } from 'src/utils/post-login-redirect';

// Consumes the stored redirect once and freezes it, so the several AuthRoute
// re-renders right after login don't read the now-cleared value and fall back.
export const usePostLoginRedirect = (enabled, fallback) => {
  const targetRef = useRef(undefined);

  if (enabled && targetRef.current === undefined) {
    targetRef.current = consumePostLoginRedirect() || fallback;
  }

  return enabled ? targetRef.current : fallback;
};
